import { Link } from 'react-router-dom';
import Icon from '../Components/Icons/Icon';
import { useCart } from '../context/CartContext';
import { formatNpr } from '../lib/currency';
import { getOptimizedImageUrl } from '../lib/imageUrl';
import { getProductDisplayId } from '../lib/productDisplayId';

function CartPage() {
  const { cart, cartError, cartIsLoading, clearAll, removeItem, updateItem } = useCart();

  return (
    <section className="page-card">
      <h1 className="page-card__title">Cart</h1>
      <p className="page-card__text">
        Review your selected items, adjust quantities, and keep the order ready for checkout.
      </p>
      {cartIsLoading && <p className="products-state">Loading cart...</p>}
      {cartError && <p className="products-state products-state--error">{cartError}</p>}
      {!cartIsLoading && cart.items.length === 0 && (
        <div className="cart-empty">
          <span className="cart-empty__icon"><Icon name="bag" size={30} /></span>
          <h2>Your cart is empty</h2>
          <p>Browse our collection and find frames made for you.</p>
          <Link className="green-button cart-empty__cta" to="/products">
            Browse Products
          </Link>
        </div>
      )}
      {cart.items.length > 0 && (
        <div className="cart-layout">
          <div className="cart-items">
            {cart.items.map((item) => (
              <article key={item.id} className="cart-item">
                <img
                  className="cart-item__image"
                  src={getOptimizedImageUrl(item.product.image, 300)}
                  alt={item.product.name}
                  loading="lazy"
                  decoding="async"
                />
                <div className="cart-item__content">
                  <p className="cart-item__category">{item.product.category}</p>
                  <h2 className="cart-item__title">{item.product.name}</h2>
                  <p className="cart-item__id">Product ID: {getProductDisplayId(item.product.id)}</p>
                  <p className="cart-item__description">{item.product.description}</p>
                  <p className="cart-item__price">{formatNpr(item.product.price)}</p>
                </div>
                <div className="cart-item__actions">
                  <div className="cart-quantity">
                    <button
                      type="button"
                      onClick={() => {
                        void updateItem(item.id, item.quantity - 1).catch(() => {});
                      }}
                    >
                      -
                    </button>
                    <span>{item.quantity}</span>
                    <button
                      type="button"
                      onClick={() => {
                        void updateItem(item.id, item.quantity + 1).catch(() => {});
                      }}
                    >
                      +
                    </button>
                  </div>
                  <p className="cart-item__total">{formatNpr(item.lineTotal)}</p>
                  <button
                    type="button"
                    className="cart-item__remove"
                    onClick={() => {
                      void removeItem(item.id).catch(() => {});
                    }}
                  >
                    Remove
                  </button>
                </div>
              </article>
            ))}
          </div>

          <aside className="cart-summary">
            <h2>Order Summary</h2>
            <div className="cart-summary__line">
              <span>Items</span>
              <strong>{cart.itemCount}</strong>
            </div>
            <div className="cart-summary__line cart-summary__line--total">
              <span>Total</span>
              <strong>{formatNpr(cart.subtotal)}</strong>
            </div>
            <Link className="green-button cart-summary__checkout" to="/checkout">
              Proceed to Checkout
            </Link>
            <button
              type="button"
              className="cart-summary__clear"
              onClick={() => {
                void clearAll().catch(() => {});
              }}
            >
              Clear Cart
            </button>
          </aside>
        </div>
      )}
    </section>
  );
}

export default CartPage;
